import { render, staticRenderFns } from "./CriminalRecordList.vue?vue&type=template&id=69e1903f&"
import script from "./CriminalRecordList.vue?vue&type=script&lang=js&"
export * from "./CriminalRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports